import type { ReactNode } from 'react';
import { CabinetContext } from './CabinetContext';
import type { CabinetConfig } from './types';
import type { StorageScope } from '../../lib/storage';

interface ProviderProps {
  config: CabinetConfig;
  scope: StorageScope;
  children: ReactNode;
}

export function CabinetConfigProvider({ config, scope, children }: ProviderProps) {
  return <CabinetContext.Provider value={{ config, scope }}>{children}</CabinetContext.Provider>;
}
